module.exports = "pegasus_template/assets/themelp1/app/106.png";